// @ts-ignore
import { COURSE_SUBSCRIPTION_TIERS } from "@seneca/course-service-client/dist/CourseSubscriptionTiers";

import Course from "../../../../models/state/courses/course/Course";
import { SectionId } from "../../../../models/state/sections/section/Section";

export function getCourseId(course: Course) {
  return course?.id;
}

export function getCourseName(course: Course) {
  return course?.name;
}

export function getCourseDescription(course: Course) {
  return course?.description;
}

export function getCourseAuthors(course: Course) {
  return course?.authors;
}

export function getCourseReferences(course: Course) {
  return course?.references;
}

export function getCourseHeaderImageURL(course: Course) {
  return course?.headerImageURL;
}

export function getCourseAvailable(course: Course) {
  return course?.available;
}

export function getCourseSectionIds(course: Course) {
  return course?.sectionIds;
}

export function getRelatedCourseIds(course: Course) {
  return course?.relatedCourseIds;
}

export function getCourseSubscriptionTier(course: Course) {
  return course?.subscriptionTier;
}

export function courseIsFree(course: Course): boolean {
  return course?.subscriptionTier === COURSE_SUBSCRIPTION_TIERS.FREE;
}

export function courseIsPremium(course: Course): boolean {
  return course?.subscriptionTier === COURSE_SUBSCRIPTION_TIERS.PREMIUM;
}

export function getCourseAverageScorePercentiles(course: Course) {
  return course?.averageScorePercentiles;
}

export function getCourseStartingSectionId(
  course: Course
): SectionId | null | undefined {
  return course?.startingSectionId;
}

export function getCourseTagIds(course: Course) {
  return course?.tags;
}

export function getCourseRegion(course: Course) {
  return course.regions.get(0);
}

export function getCourseExamQuestionsCount(course: Course) {
  return course?.examQuestionsCount;
}

export function doesCourseHaveExamQuestions(course: Course) {
  return !!getCourseExamQuestionsCount(course);
}
